import { ComponentRef, Directive, inject, Input, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { startWith, takeUntil } from 'rxjs/operators';
import { MessagesListContextMenuComponent } from '../components/messages-list-context-menu/messages-list-context-menu.component';
import { MessageListStateService } from '../services/message-list-state.service';

@Directive({
  selector: '[appMessagesListContextMenu]',
  standalone: false,
})
export class MessagesListContextMenuDirective extends ContextMenuDirective implements OnInit {
  @Input()
  public appMessagesListContextMenuWithAdvancedSearch: boolean;
  @Input()
  public appMessagesListContextMenuWithScore: boolean;
  @Input()
  public appMessagesListContextMenuWithToSort?: boolean;
  @Input()
  public appMessagesListContextMenuWithFromSort?: boolean;
  @Input()
  public appMessagesListContextMenuWithThreadedView?: boolean;
  @Input()
  public appMessagesListContextMenuWithUnreadFilter?: boolean;
  @Input()
  public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input()
  public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly messageListStateService = inject(MessageListStateService);

  /**
   * Context Menu Interface
   */

  registerInstance(componentRef: ComponentRef<MessagesListContextMenuComponent>) {
    componentRef.instance.state = this.messageListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appMessagesListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appMessagesListContextMenuWithScore;
    componentRef.instance.withToSort = this.appMessagesListContextMenuWithToSort;
    componentRef.instance.withFromSort = this.appMessagesListContextMenuWithFromSort;
    componentRef.instance.withThreadedView = this.appMessagesListContextMenuWithThreadedView;
    componentRef.instance.withUnreadFilter = this.appMessagesListContextMenuWithUnreadFilter;
  }

  registerComponent() {
    return MessagesListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.messageListStateService.state
      .changes()
      .pipe(startWith(null), takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.messageListStateService.state.isDefault());
      });

    this.isDefaultStateObservable?.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.messageListStateService.state.isDefault()) {
        this.messageListStateService.state.resetToDefault();
      }
    });
  }
}
